import { atom } from 'jotai';

export const TagViewDialogAtom = atom<boolean>(false);
